module.exports = __webpack_public_path__ + "media/images/logos/simrad-lg-cfb27ef51b3b8c54aef0faafb7c8a739.png";